import { Container } from '../../../odie';

import { HazardBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const manifest = {
  image: 'virus/block.hazard.png',
};

/*
    hazard block view
*/
export class HazardBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: HazardBlockProps) {
    // spawn
    super();
    const watermelon = new FitWidthBlockSprite(manifest.image, props);
    watermelon.scaleX *= 1.1;
    watermelon.scaleY *= 1.1;
    this.addChild(watermelon);

    // position
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return [manifest.image];
  }
}
